import { render, staticRenderFns } from "./BaseDadosOrcamentos.vue?vue&type=template&id=39e63962&scoped=true&"
import script from "./BaseDadosOrcamentos.vue?vue&type=script&lang=js&"
export * from "./BaseDadosOrcamentos.vue?vue&type=script&lang=js&"
import style0 from "./BaseDadosOrcamentos.vue?vue&type=style&index=0&id=39e63962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e63962",
  null
  
)

export default component.exports